import React from 'react';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { detectLoyaltyIntegration, useLoyalty, Statuses } from 'src/components/loyalty/use-loyalty';

import { SmallLoader } from 'shared/components';
import { DialogContainer } from 'src/components/modals/components/simple-dialog';
import { Connect } from './connect';
import { Terms } from './terms';
import { Pin } from './pin';

type LoyaltyProps = {
  onClose: (result?: { status: Statuses }) => void;
};

export const Loyalty = ({ onClose }: LoyaltyProps): JSX.Element => {
  const { dispensary } = useDispensary();
  const { status, setStatus, programName, programDescription, createUserAndPin, processPin, resendPin } = useLoyalty({
    initialStatus: Statuses.signup,
    integration: detectLoyaltyIntegration(dispensary),
  });

  const handleClose = (): void => {
    onClose({ status });
  };
  return (
    <DialogContainer>
      {status === Statuses.loading && <SmallLoader />}
      {status === Statuses.signup && (
        <Connect
          onClose={handleClose}
          setStatus={setStatus}
          programName={programName}
          programDescription={programDescription}
        />
      )}
      {status === Statuses.terms && (
        <Terms onClose={handleClose} programName={programName} createUserAndPin={createUserAndPin} />
      )}
      {[Statuses.pin, Statuses.incorrectPin, Statuses.success].includes(status) && (
        <Pin
          onClose={handleClose}
          status={status}
          programName={programName}
          processPin={processPin}
          resendPin={resendPin}
        />
      )}
    </DialogContainer>
  );
};
